import { createReducer, on } from '@ngrx/store';
import { profileActions } from '../actions/profile.actions';
import { User } from '../models';

export interface ProfileState {
    loaded: boolean | null;
    loading: boolean | null;
    saving: boolean;
    saved: boolean;
    passwordSaving: boolean;
    passwordSaved: boolean;
    passwordError: number | null;
    profile: User | null;
}

export const initialState: ProfileState = {
    loaded: null,
    loading: null,
    saving: false,
    saved: false,
    passwordSaving: false,
    passwordSaved: false,
    passwordError: null,
    profile: null,
};

export const profileReducer = createReducer(
    initialState,
    // Get
    on(profileActions.getProfile, (state): ProfileState => ({
        ...state,
        loading: true,
        loaded: null,
    })),
    on(profileActions.getProfileSuccess, (state, { payload }): ProfileState => ({
        ...state,
        loading: false,
        loaded: true,
        profile: payload,
    })),
    on(profileActions.getProfileError, (state): ProfileState => ({
        ...state,
        loading: false,
        loaded: false,
    })),
    // Update
    on(profileActions.updateProfile, (state): ProfileState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(profileActions.updateProfileSuccess, (state, { payload }): ProfileState => ({
        ...state,
        saving: false,
        saved: true,
        profile: payload,
    })),
    on(profileActions.updateProfileError, (state): ProfileState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    // Change Password
    on(profileActions.changePassword, (state): ProfileState => ({
        ...state,
        passwordSaving: true,
        passwordSaved: false,
        passwordError: null,
    })),
    on(profileActions.changePasswordSuccess, (state): ProfileState => ({
        ...state,
        passwordSaving: false,
        passwordSaved: true,
        passwordError: null,
    })),
    on(profileActions.changePasswordError, (state, { code }): ProfileState => ({
        ...state,
        passwordSaving: false,
        passwordSaved: false,
        passwordError: code,
    })),
    // Clear
    on(profileActions.clear, (): ProfileState => ({ ...initialState })),
);
